import Vue from 'vue'
import App from './App.vue'
import { sync } from 'vuex-router-sync'
import router from './router'
import store from './store'
import './registerServiceWorker'
import './assets/css/main.css'
import './validation'
import sanitizeHTML from 'sanitize-html'
import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'
import Dialogs from './components/dialogs'
Vue.use(Dialogs)

// Sanitize WYSIWYG from user
Vue.prototype.$sanitize = sanitizeHTML

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    environment: process.env.NODE_ENV,
    dsn: process.env.VUE_APP_SENTRY_VUE_DSN,
    integrations: [new Integrations.Vue({ Vue, attachProps: true, logErrors: true })]
  })
}

// Sync Route State with Vuex
sync(store, router)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
